import * as Sentry from '@sentry/browser';
import axios from 'axios';

export default {
     state: {
          roles: [],
          loading: true,
          notificationBanner: undefined,
     },
     getters: {
          roles: state => state.roles,
          loading: state => state.loading,
     },
     mutations: {
          setRoles: (state, roles) => {
               state.roles = roles;
          },
          setLoading: (state, loading) => {
               state.loading = loading;
          },
          setNotifications: (state, notifications) => {
               state.notificationBanner = notifications;
          },
     },
     actions: {
          setLoading: (context, payload) => {
               context.commit('setLoading', payload);
          },
          getRoles: async ({ commit }) => {
               try {
                    const rolesData = await axios({
                         method: 'GET',
                         url: process.env.VUE_APP_API_URI + '/roles',
                    });

                    if (rolesData.data.length >= 0) {
                         const roles = rolesData.data;
                         commit('setRoles', roles);
                    }
               } catch (e) {
                    Sentry.captureException(e);
                    return false;
               }
          },
     },
};
